import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  OverlayTrigger,
  Button,
  Card,
  Row,
  Col,
  Tooltip
} from 'react-bootstrap';
import classNames from 'classnames';
import { useAuth } from 'react-oidc-context';
import { GET_LISTINGS } from 'graphql/listing';
import { setListings } from 'reducers/homeReducer';
import GridView from './GridView';
import MapView from './MapView';

const Home = () => {
  const dispatch = useDispatch();
  const { address } = useSelector(state => state.profile);
  const auth = useAuth();
  const { data } = useQuery(GET_LISTINGS, {
    variables: {
      excludes: [auth?.user?.profile?.sub]
    },
    skip: !address
  });

  const { listings } = useSelector(state => state.home);

  const [listType, setListType] = useState('grid');

  const handleSwitchView = () => {
    setListType(listType === 'grid' ? 'map' : 'grid');
  };

  useEffect(() => {
    if (!data) {
      return;
    }
    dispatch(setListings(data.listings.items));
  }, [data]);

  return (
    <>
      <Card className="mb-3">
        <Card.Body>
          <Row className="flex-between-center g-2">
            <Col md></Col>
            <Col xs="auto">
              <Button variant="outline-primary" type="submit">
                Filters
              </Button>
            </Col>
            <Col xs="auto">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip style={{ position: 'fixed' }}>
                    {listType === 'grid' ? 'Grid' : 'Map'} View
                  </Tooltip>
                }
              >
                <Link onClick={handleSwitchView} className="text-600 px-1">
                  <FontAwesomeIcon
                    icon={classNames({
                      map: listType === 'map',
                      'list-ul': listType === 'grid'
                    })}
                  />
                </Link>
              </OverlayTrigger>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card className={classNames({ 'home-body': listType === 'map' })}>
        <Card.Body
          className={classNames({
            'pb-0': listType === 'grid',
            'h-100': listType === 'map'
          })}
        >
          {listings.length === 0 && <p>No results.</p>}
          {listings.length > 0 && listType === 'grid' && <GridView />}
          {listings.length > 0 && listType === 'map' && <MapView />}
        </Card.Body>
        <Card.Footer
          className={classNames('d-flex justify-content-center', {
            'bg-body-tertiary mt-n1': listType === 'grid',
            'border-top': listType === 'list'
          })}
        ></Card.Footer>
      </Card>
    </>
  );
};

export default Home;
